<template>
  <div>
    <common-dialog
      ref="dialog"
      width="700px"
      :show-save-button="$permission.canEdit()"
      unit="配送公司"
      edit-title
      id-key="RecordId"
      :data="data"
      form-label-width="125px"
      :form-rules="rules"
      :save-func="api.save"
      @create-opened="onCreateOpened"
      @edit-opened="onEditOpened"
      close-on-saved
      :before-save="onBeforeSave"
      @closed="onClosed"
      @close-saved="$emit('close-saved')"
    >
      <template slot="form">
        <el-row>
          <el-col :span="isMB ? 24 : 12">
            <el-form-item label="公司名称" prop="CompanyName">
              <el-input
                v-model="data.CompanyName"
                placeholder="请填写公司名称"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="isMB ? 24 : 12" v-if="loginInfo.UserType == 0">
            <el-form-item
              label="所属商家"
              prop="StoreId"
              :rules="loginInfo.UserType == 0 ? typeRules.StoreId : null"
            >
              <busi-select
                v-model="data.StoreId"
                ref="busiSelect"
                :checkState="checkState"
              ></busi-select>
            </el-form-item>
          </el-col> -->
        </el-row>
        <el-row>
          <el-col :span="isMB ? 24 : 12">
            <el-form-item label="联系人" prop="ContactName">
              <el-input
                v-model="data.ContactName"
                placeholder="请填写联系人"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="isMB ? 24 : 12">
            <el-form-item label="联系电话" prop="ContactPhone">
              <el-input
                v-model="data.ContactPhone"
                placeholder="请填写联系电话"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="isMB ? 24 : 12">
            <el-form-item label="快递编码" prop="ContactCom">
              <el-input
                v-model="data.ContactCom"
                placeholder="请填写快递编码"
                clearable
              ></el-input>
              <el-link @click="download" icon="el-icon-download" type="primary"
                >快递公司编码表</el-link
              >
            </el-form-item>
          </el-col>
          <el-col :span="isMB ? 24 : 12">
            <el-form-item label="状态" prop="State">
              <el-radio-group v-model="data.State">
                <el-radio :label="1">启用</el-radio>
                <el-radio :label="0">停用</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="isMB ? 24 : 12">
            <el-form-item label="序号" prop="OrderId">
              <el-input-number v-model="data.OrderId" :min="0" />
            </el-form-item>
          </el-col>
        </el-row>
      </template>
      <template #footer v-if="!$permission.canEdit()">
        <el-button @click="close">关 闭</el-button>
      </template>
    </common-dialog>
  </div>
</template>
  <script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import busiSelect from "@/components/shop/business/select";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    busiSelect,
  },
  data() {
    return {
      data: {
        RecordId: 0,
        CompanyName: "",
        ContactName: "",
        ContactPhone: "",
        ContactCom: "",
        OrderId: 0,
        State: 1,
        StoreId: null,
      },
      api: require("@/api/sale/expcompany").default,
      attach: require("@/api/common/attach").default,
      isMB: this.$store.state.isMB,
      rules: {
        CompanyName: [{ required: true, message: "公司名称不能为空" }],
        ContactPhone: [{ validator: this.$commonJs.validateRules.validPhone2 }],
        OrderId: [{ required: true, message: "序号不能为空" }],
        ContactCom: [{ required: true, message: "快递编码不能为空" }],
      },
      typeRules: {
        StoreId: [{ required: true, message: "请选择所属商家" }],
      },
      loginInfo: JSON.parse(localStorage.getItem("loginInfo")),
      checkState: 2,
    };
  },
  watch: {
    // "data.StoreId": function (newValue, oldValue) {
    //   console.log(newValue, oldValue);
    //   this.data.StoreId = newValue;
    //   if (this.data.RecordId == 0) {
    //     if (this.data.StoreId > 0) {
    //       this.api.getMaxOrderId(this.data.StoreId).then((res) => {
    //         if (res.Code == 0) this.data.OrderId = res.Data;
    //       });
    //     }
    //   }
    // },
  },
  methods: {
    download() {
      var name = "快递公司编码表.xlsx";
      this.attach.downloadByUrl("/Template/" + name, name);
    },
    onCreateOpened(row) {
      // this.api.getMaxOrderId().then((res) => {
      //   if (res.Code == 0) this.data.OrderId = res.Data;
      // });
      this.initMaxOrderId();
    },
    onEditOpened(row) {},
    onBeforeSave() {},
    onClosed() {},
    initMaxOrderId() {
      this.api.getMaxOrderId().then((res) => {
        if (res.Code == 0) this.data.OrderId = res.Data;
      });
    },
  },
};
</script>